export default __webpack_public_path__ + "ca73cfc87e01fe8777bce9a36a0307e8.jpg";